import { useAiBuilderTypewriter } from '../hooks';
import { type AiBuilderMessage, useAiBuilderChatActions } from '../stores';
import { AiBuilderActionChip } from './AiBuilderActionChip';
import { AiBuilderAssistantMarkdownContent } from './AiBuilderAssistantMarkdownContent';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
const AI_BUILDER_CLOSE_ACTION_CHIP_CLASS_NAME = 'border-transparent bg-transparent text-neutral hover:bg-neutral focus-visible:bg-neutral';
export const AiBuilderAssistantMessage = ({
  message,
  progressMessage,
  isStreaming = false
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'assistant';
  }>;
  progressMessage?: Extract<AiBuilderMessage, {
    kind: 'progress';
  }>;
  isStreaming?: boolean;
}) => {
  const {
    focusQuizByNumber,
    submitAssistantAction
  } = useAiBuilderChatActions();
  // 실제 스트리밍 중인 메시지에 타이핑 효과를 준다. progress 카드 동반 여부와
  // 무관하다 — progress 는 제거되지 않고 settle 만 되므로 스트리밍 중 row key
  // (assistant.id 또는 progress.id:assistant.id)가 불변이라 리마운트가 없다.
  // 완성/복원된 메시지(isStreaming=false)는 즉시 전문을 표시한다.
  const displayedContent = useAiBuilderTypewriter({
    fullText: message.content,
    enabled: isStreaming
  });
  const hasBody = message.content.length > 0;
  return <div className="flex min-w-0 flex-col gap-none" data-sentry-component="AiBuilderAssistantMessage" data-sentry-source-file="AiBuilderAssistantMessage.tsx">
      <AiBuilderChatMessageAI data-sentry-element="AiBuilderChatMessageAI" data-sentry-source-file="AiBuilderAssistantMessage.tsx">
        {progressMessage && <AiBuilderChatMessageAI.Progress message={progressMessage} />}
        {hasBody && <AiBuilderChatMessageAI.Body>
            <AiBuilderAssistantMarkdownContent content={displayedContent} />
          </AiBuilderChatMessageAI.Body>}
        {message.jumpLinks != null && message.jumpLinks.length !== 0 && <AiBuilderChatMessageAI.JumpLinks links={message.jumpLinks} onLinkClick={focusQuizByNumber} />}
        {hasBody && <AiBuilderChatMessageAI.Copy text={message.content} feedbackMessage={message} />}
      </AiBuilderChatMessageAI>

      {message.actions != null && message.actions.length !== 0 && <div className="flex min-w-0 max-w-full flex-col items-end gap-xs pb-md pl-md pr-sm laptop-sm:pl-3xl laptop-sm:pr-lg">
          {message.actions.map(action => <AiBuilderActionChip key={action.id} emoji={action.type === 'prompt' ? action.emoji : action.type === 'undoLastAiAction' ? '↩️' : undefined} className={action.type === 'closePanel' ? AI_BUILDER_CLOSE_ACTION_CHIP_CLASS_NAME : undefined} label={action.label} onClick={() => submitAssistantAction(message.id, action)} title={action.label} />)}
        </div>}
    </div>;
};